import { useQuery } from "@apollo/client";
import { useAuth0 } from "@auth0/auth0-react";
import { constantsData } from "data";
import { getClientRevenueReportsTemplatesListQuery } from "graph";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { openAlert } from "redux/actions";
import { displayErrorHandler } from "utils";

const useGetClientRevenueReportsTemplatesList = (id) => {
    const { isAuthenticated } = useAuth0();

    const { t } = useTranslation();

    const dispatch = useDispatch();

    const {
        data,
        error,
        loading,
        refetch,
    } = useQuery(
        getClientRevenueReportsTemplatesListQuery,
        {
            skip: !isAuthenticated || !id,
            variables: { id },
        },
    );

    useEffect(
        () => {
            if (error?.message === constantsData.failedToFetch && !loading) {
                displayErrorHandler(
                    t("messages.networkFailure"),
                    dispatch,
                    openAlert,
                );
            }
        },
        [error, data], // eslint-disable-line
    );

    return {
        data: data?.getClientReportTemplates,
        loading,
        refetch,
    };
};

export default useGetClientRevenueReportsTemplatesList;
